import { motion } from "framer-motion";

const EclipseRing = ({ size = 560, className = "", duration = 70 }) => (
  <div
    className={`pointer-events-none select-none ${className}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <motion.svg
      viewBox="0 0 200 200"
      className="w-full h-full"
      animate={{ rotate: 360 }}
      transition={{ duration, repeat: Infinity, ease: "linear" }}
    >
      <defs>
        <linearGradient id="gold-ring" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#C8A66A" stopOpacity="0.04" />
          <stop offset="55%" stopColor="#C8A66A" stopOpacity="0.55" />
          <stop offset="88%" stopColor="#EAD9B0" stopOpacity="1" />
          <stop offset="100%" stopColor="#EAD9B0" stopOpacity="1" />
        </linearGradient>
        <filter id="ring-glow" x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="2.2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <circle
        cx="100"
        cy="100"
        r="86"
        fill="none"
        stroke="url(#gold-ring)"
        strokeWidth="0.9"
        strokeDasharray="502 38"
        strokeLinecap="round"
        filter="url(#ring-glow)"
      />
      <circle cx="100" cy="14" r="3" fill="#EAD9B0" filter="url(#ring-glow)" />
    </motion.svg>
  </div>
);

export default EclipseRing;
